// Copyright © 2021 Move Closer
import { Site } from '@modules/front';
// import { ISubscriptionService } from '@subscription/shared/services'
var SiteUnknown;
(function (SiteUnknown) {
    SiteUnknown["Unknown"] = "unknown";
})(SiteUnknown || (SiteUnknown = {}));
export const Domain = { ...Site, ...SiteUnknown };
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var SiteFaviconType;
(function (SiteFaviconType) {
    SiteFaviconType["Png"] = "png";
    SiteFaviconType["Svg"] = "svg";
})(SiteFaviconType || (SiteFaviconType = {}));
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var SiteLogoVariant;
(function (SiteLogoVariant) {
    SiteLogoVariant["Dark"] = "dark";
    SiteLogoVariant["Light"] = "light";
})(SiteLogoVariant || (SiteLogoVariant = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const SiteMiddlewareType = Symbol.for('SiteMiddleware');
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const SiteServiceType = Symbol.for('ISiteService');
